var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalal = function SvgHalal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Halal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Halal_svg__b)",
    d: "M35.055 20.232c-.36 1.199-.968 1.617-2 1.825-1.364.269-2.647.933-3.995 1.31-1.306.364-2.639.717-3.98.821-1.597.123-2.319-.618-2.568-2.22-.289-1.85-.577-3.702-.984-5.561-.88 2.904-1.017 6.134-3.898 8.004-1.751 1.137-3.722 1.505-5.83 1.379.476-.188.94-.423 1.432-.56 4.44-1.253 6.322-4.652 7.267-8.765.396-1.721.538-3.5 1.014-5.277.334 1.866.641 3.744 1.018 5.603.288 1.417.595 2.838 1.033 4.213.55 1.732 1.686 2.416 3.449 1.967 1.574-.4 3.084-1.049 4.624-1.587l.011-.437c-1.136-.411-2.262-1.118-3.41-1.156-1.114-.039-2.25.607-3.338.944.988-2.362 2.432-2.984 4.605-1.774 1.71.949 3.48 1.479 5.55 1.271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Halal_svg__c)",
    d: "M5.131 21.239c0 .16.008.326 0 .487-.107 2.47.634 3.46 3.664 2.827 2.04-.426 3.676-1.36 3.33-4.22-.322-2.662-.607-5.332-.887-7.997-.05-.492-.008-.991-.008-1.832.907 1.002 1.383 1.613 1.337 2.761-.077 1.967.215 3.956.426 5.927.45 4.144-2.085 6.99-6.287 6.997-1.986 0-2.911-1.094-2.496-3.026.146-.669.422-1.31.641-1.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Halal_svg__d)",
    d: "M18.693 20.054c-.96-1.959-2.205-3.25-3.86-4.232-.572-.342-.772-1.314-1.252-2.209 2.67.507 4.736 3.18 5.112 6.441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Halal_svg__e)",
    d: "M19.124 1.901c9.433 0 17.11 7.674 17.11 17.11s-7.674 17.11-17.11 17.11-17.11-7.677-17.11-17.11 7.677-17.11 17.11-17.11m0-1.901C8.624 0 .112 8.511.112 19.011s8.511 19.012 19.012 19.012c10.5 0 19.011-8.511 19.011-19.012C38.135 8.511 29.625 0 19.124 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Halal_svg__b",
    x1: 17.614,
    x2: 25.147,
    y1: 11.188,
    y2: 29.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Halal_svg__c",
    x1: 6.345,
    x2: 17.535,
    y1: 10.504,
    y2: 20.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Halal_svg__d",
    x1: 14.859,
    x2: 19.441,
    y1: 13.613,
    y2: 19.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Halal_svg__e",
    x1: 9.618,
    x2: 34.967,
    y1: 0,
    y2: 38.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Halal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.065 0h38v38h-38z"
  })))));
};
export default SvgHalal;